export const baseAPIAddress = process.env.REACT_APP_API_URL;

export const GET_VIRTUAL_CARDS = "card/list";
export const GET_PHYSICAL_CARDS = "card/list/physical";
export const GET_AGENT_TRANSACTION_LIST = "wallet/transactions";
